import List from './List';
import Form from './Form';

const Components = {
  List,
  Form
}

export default Components